import store from '@/store'

const prefix = '/admin/reports/finance'

export default [
  {
    path: prefix + '/pay-to-vendors',
    name: 'pay-to-vendor',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/finance/pay-to-vendor')
  },
  {
    path: prefix + '/income-statement-details',
    name: 'income-statement-details',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/finance/income-statment-detail')
  },
  {
    path: prefix + '/gross-profit',
    name: 'gross-profit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/finance/gross-profit')
  },
  {
    path: prefix + '/sale-by-customer-summaries',
    name: 'sale-by-customer-summary',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/finance/sale-by-customer-summary')
  },
  {
    path: prefix + '/account-receivables',
    name: 'account-receivable',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/finance/account-receivable')
  },
  {
    path: prefix + '/cash-collections',
    name: 'cash-collection',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/finance/cash-collection')
  }
]
